import { render, staticRenderFns } from "./child-2.vue?vue&type=template&id=2be89b16&scoped=true"
import script from "./child-2.vue?vue&type=script&lang=js"
export * from "./child-2.vue?vue&type=script&lang=js"
import style0 from "./child-2.vue?vue&type=style&index=0&id=2be89b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be89b16",
  null
  
)

export default component.exports